// Reusable Checkbox Component (React + Tailwind)
export const CustomCheckbox = ({ label, checked, onChange }) => (
    <label className="flex items-center space-x-2 cursor-pointer dark:text-white text-[14px]">

        <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className="hidden"
        />
        <div className={`w-5 h-5 rounded-md flex items-center justify-center 
      ${checked ? 'bg-[#A6E8A5]' : 'border-2 border-gray-400'}`}>
            {checked && (
                <svg
                    className="w-5 h-5 text-black"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    viewBox="0 0 24 24"
                >
                    <path d="M5 13l4 4L19 7" />
                </svg>
            )}
        </div>
        <span>{label}</span>
    </label>
);
